export const linkConverter = (content: string[]): string[] => {
  return content.map((sentence) => {
    let modifiedSentence = sentence;
    const includeLink = sentence.includes('<a');
    if (includeLink) {
      const div = document.createElement('div');
      div.innerHTML = sentence;

      const links = div.querySelectorAll('a');
      links.forEach((link) => {
        link.removeAttribute('style');
        link.removeAttribute('class');
        link.setAttribute('variant', 'inline');
        link.setAttribute('target', '_blank');
      });

      const replaceStartTag = div.innerHTML.replace(/<a/g, '<wb7-link');
      const replaceEndTag = replaceStartTag.replace(/<\/a/g, '</wb7-link');

      modifiedSentence = replaceEndTag;
    }

    return modifiedSentence;
  });
};
